import { TASK_TYPES } from "./actionTypes";
import { TASK_CONFIG } from "./constants";

export const initialSupportWorkState = () => ({
  activeTaskType: "",
  isFetchingCase: false,
  isTakingBackup: false,
  isDeleting: false,
  caseDetails: null,
  isBackupTaken: false,
  backupFileName: null,
  noBackupData: false,
  deleteResponse: null,
  error: null,
});

export const isDeleteTask = (taskType) =>
  taskType === TASK_TYPES.DELETE_FINANCIAL_FORM_DATA ||
  taskType === TASK_TYPES.DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA;

export const buildCaseDetails = (responseData = {}) => ({
  caseId: responseData.caseId || "",
  caseName: responseData.caseName || responseData.counterpartyName || "",
  corporateName: responseData.corporateName || "",
  counterpartyName: responseData.counterpartyName || "",
  counterpartyId: responseData.counterpartyId || "",
  computedReportId: responseData.computedReportId || "",
  status: responseData.status || "",
  hasFinancialFormData: Boolean(responseData.hasFinancialFormData),
  hasExecutiveSummaryFinancialData: Boolean(
    responseData.hasExecutiveSummaryFinancialData
  ),
});

export const hasDeletableDataForTask = (caseDetails, taskType) => {
  const taskConfig = TASK_CONFIG[taskType];
  if (typeof taskConfig?.hasDeletableData === "function") {
    return taskConfig.hasDeletableData(caseDetails);
  }
  return false;
};

export const mapAutomationResponse = (response) => {
  const data = response?.data || response || {};
  return {
    caseId: data.caseId || "",
    counterpartyId: data.counterpartyId || "",
    computedReportId: data.computedReportId || "",
    deletedRecordsCount: data.deletedRecordsCount,
    message: data.message || "",
  };
};

export const extractApiErrorMessage = (err, fallbackMessage) => {
  const responseData = err?.response?.data;

  if (!responseData) {
    return err?.message || fallbackMessage;
  }

  if (typeof responseData === "string") {
    return responseData;
  }

  if (responseData.message) {
    return responseData.message;
  }

  return fallbackMessage;
};

export const isNoBackupDataMessage = (message = "") => {
  const lowerMessage = String(message).toLowerCase();
  return (
    lowerMessage.includes("no financial form data") ||
    lowerMessage.includes("no executive summary") ||
    lowerMessage.includes("no data available to take backup") ||
    (lowerMessage.includes("no ") && lowerMessage.includes("found"))
  );
};

export const getErrorMessage = (error) =>
  error?.message ||
  error?.data?.message ||
  "Something went wrong. Please try again later.";

export const validateCaseId = (caseId) => {
  if (!caseId || !caseId.trim()) {
    return "Please enter case ID";
  }
  return "";
};

export const validateDeleteAction = ({
  caseDetails,
  isBackupTaken,
  requiresBackup = true,
}) => {
  if (!caseDetails?.caseId) {
    return "Please fetch case details before deleting";
  }
  if (requiresBackup && !isBackupTaken) {
    return "Please take backup before deleting data";
  }
  return "";
};
